import styled from 'styled-components';

const Title = styled.h3`
  margin-top: 0;
`;

export default Title;
